import { useStyles } from './useStyles';
import { Grid, IconButton } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { EditButton, LinkButton } from '../../components/atoms/Button';
import { useHooks } from './useHooks';
import { SITE_PROCESS_DISPLAY_MODE } from '../../const/ProcessConst';
import { SiteProcessSelectfield } from '../../components/parts/input/ProcessSelectfield';
import { FormProvider, UseFormReturn, useForm } from 'react-hook-form';
import BasePageLayoutWrapper from '../../components/parts/common/BasePageLayoutWrapper';
import { EmptySiteProcessView } from '../../components/parts/process/EmptyProcessView';
import { MoreVert } from '@material-ui/icons';
import LoadingIcon from '../../components/atoms/LoadingIcon';
import LoadingIconClear from '../../components/atoms/LoadingIconClear';
import { useRecoilState } from 'recoil';
import { userMenuId } from '../../GlobalState';
import { AuthInfoContext } from '../../AuthContextProvider';
import { ROLE } from '../../const/Const';
import { TSelectItem } from '../../types/common';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { AttendanceGanttView } from '../../components/parts/attendance/AttendanceGanttView';
import { AttendanceAddModal } from '../../components/parts/attendance/AttendanceAddModal';

export type TPageForm = {
  construct_id: { value: number; label: string };
};

type TProps = {
  setConstructListVal: any;
  constructListVal: TSelectItem;
  selectTab: number;
  initialVisibleRange: any;
};

export const AttendanceManage: React.FC<TProps> = (props: TProps) => {
  const {
    setConstructListVal,
    constructListVal,
    selectTab,
    initialVisibleRange
  } = props;

  const classes = useStyles();
  const [userMenu, setUserMenu] = useRecoilState<any>(userMenuId);

  // hook-formの初期設定
  const methods: UseFormReturn<TPageForm> = useForm();
  const { getValues } = methods;
  const [authInfo, setAuthInfo] = useContext(AuthInfoContext);
  //プルダウンで表示する選択肢
  const [filteredConstructList, setFilteredConstructList] = useState<
    TSelectItem[]
  >([]);

  const {
    constructList,
    constructId,
    renderCurrentConstructView,
    isOpenAdd,
    setIsOpenAdd,
    customerName,
    isOpenAddOfGantt,
    setIsOpenAddOfGantt,
    handleOnClickAddOfGantt,
    isDownloading,
    isLoadingGantt,
    setIsLoadingGantt
  } = useHooks({ getValues, setConstructListVal, constructListVal, selectTab });

  //デフォルト値以外を選択肢として取得する
  useEffect(() => {
    setFilteredConstructList(constructList.filter(item => item.value !== 0));
  }, [constructList, selectTab]);

  const theme = useTheme();
  const isSmDownScreen = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <>
      <div className={classes.containerPadding}>
        {isDownloading && (
          <div className={classes.loadingIconClearWrapper}>
            <LoadingIconClear />
          </div>
        )}
        <Grid
          container
          className={`${classes.gridContainerPadding} ${classes.gridContainerBackgroundColor}`}
        >
          <Grid
            item
            xs={12}
            sm={3}
            className={`${classes.gridFirstRow} ${classes.flexWrap} ${classes.alignFlexStart}`}
          >
            {/* 案件選択 */}
            <FormProvider {...methods}>
              <SiteProcessSelectfield
                name='construct_id'
                label='案件'
                listDatas={filteredConstructList}
                value={constructListVal}
                onChange={renderCurrentConstructView}
                errorMessage={
                  constructId === 0 ? 'まず案件を選択してください' : ''
                }
                className={classes.ProcessSelectfieldWidth}
              />
            </FormProvider>
            {/* /案件選択 */}
            {!isSmDownScreen && (
              <>
                {constructId > 0 && (
                  <IconButton className={classes.moreVert}>
                    <MoreVert />
                  </IconButton>
                )}
              </>
            )}
          </Grid>

          {/* 基本レイアウト */}
          {isSmDownScreen && (
            <>
              {constructId > 0 && (
                <Grid
                  item
                  xs={12}
                  sm={9}
                  className={`${classes.textAlignRight} ${classes.flexWrap} ${classes.gridFirstRow}`}
                ></Grid>
              )}
              <Grid item sm={3}>
                <div>{customerName}</div>
              </Grid>
              {constructId > 0 && (
                <>
                  <Grid item sm={12}>
                    <hr />
                  </Grid>
                  <Grid item sm={6} className={classes.flexWrap}></Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    className={`${classes.textAlignRight} ${classes.flexWrap}`}
                  >
                    {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                      <div
                        className={
                          isLoadingGantt ? classes.disabledAddButton : ''
                        }
                      >
                        <EditButton onClick={handleOnClickAddOfGantt}>
                          人工の追加
                        </EditButton>
                      </div>
                    )}
                  </Grid>
                </>
              )}
            </>
          )}
          {/* /基本レイアウト */}
        </Grid>

        {constructId > 0 && (
          <div className={classes.displayContainer}>
            <div className={classes.chartContainer}>
              <AttendanceGanttView
                constructId={constructId}
                isOpenAddModal={isOpenAddOfGantt}
                setIsOpenAddModal={setIsOpenAddOfGantt}
                isLoading={isLoadingGantt}
                setIsLoading={setIsLoadingGantt}
                isOpenAdd={isOpenAdd}
                setIsOpenAdd={setIsOpenAdd}
                initialVisibleRange={initialVisibleRange}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};
